import { render, staticRenderFns } from "./TreemapChart.vue?vue&type=template&id=451b28d3"
import script from "./TreemapChart.vue?vue&type=script&lang=js"
export * from "./TreemapChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports